// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

Vue.config.productionTip = false

window.bugsnagObj = Bugsnag;

window.bugsnagObj.start({
  apiKey: "7e84c46f5492de4dc4fa63ff9ae1bfee",
  plugins: [new BugsnagPluginVue()]
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js